import GlobalValue from "GlobalValue";
import axios from "axios";

const chars =
  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
export function btoa(input) {
  let str = input;
  let output = "";

  for (
    let block = 0, charCode, i = 0, map = chars;
    str.charAt(i | 0) || ((map = "="), i % 1);
    output += map.charAt(63 & (block >> (8 - (i % 1) * 8)))
  ) {
    charCode = str.charCodeAt((i += 3 / 4));

    if (charCode > 0xff) {
      throw new Error(
        "'btoa' failed: The string to be encoded contains characters outside of the Latin1 range."
      );
    }

    block = (block << 8) | charCode;
  }

  return output;
}
export function _callApiMessage(_apiUrl, _apiBody) {
  const apiUrl = GlobalValue.BASE_URL + _apiUrl;
  const apiBody = _apiBody;
  // console.log("callApi", _apiUrl, _apiBody);
  return axios
    .post(apiUrl, apiBody, {
      headers: {
        // "Content-Type": "application/x-www-form-urlencoded"
      }
    })
    .then(response => {
      if (response.status === 200) {
        return response.data;
      }
    })
    .catch(error => {
      console.error(error);
    });
}
export function _callApiMessage2(_apiUrl, _apiBody) {
  const apiUrl = GlobalValue.BASE_URL2 + _apiUrl;
  const apiBody = _apiBody;
  // console.log("callApi2", _apiUrl, _apiBody);
  return axios
    .post(apiUrl, apiBody, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    })
    .then(response => {
      // console.log("response", response);
      if (response.status === 200) {
        return response.data;
      }
    })
    .catch(error => {
      console.error(error);
    });
}
export function _callApiMessage3(_apiUrl, _apiBody) {
  const apiUrl = GlobalValue.BASE_URL2 + _apiUrl;
  const apiBody = _apiBody;
  // console.log("callApi2", _apiUrl, _apiBody);
  return axios
    .post(apiUrl, apiBody, {
      headers: {
        "Content-Type": "application/json"
      }
    })
    .then(response => {
      // console.log("response", response);
      if (response.status === 200) {
        return response.data;
      }
    })
    .catch(error => {
      console.error(error);
    });
}
export function custonSort(a, b) {
  if (a.EDLastDateTime == b.EDLastDateTime) {
    return 0;
  }
  return a.EDLastDateTime < b.EDLastDateTime ? 1 : -1;
}
export const insertEdocument = {
  EDDateTime: "", // 등록 시간 - 서버 자동 계산
  EDMilliSecond: "", // 상동
  EDNumber: "", // 문서번호 - 서버 자동 계산
  EDEG1Code: "0", // 구분(인사, 공지, 교부 등등) ** 전자근로계약서 = 301
  EDEG2Code: "0", // 항목(현재 인사일때만 쓰는 중, 근태정정, 연차신청 등) 이후 전자근로계약서 동의 쪽에서 사용 예정 ** 전자근로계약서 = 1
  EDTitle: "", // 기안 제목
  EDText: "", // 기안 내용
  EJText: "", // 결재자 의견
  EDBigo: "", // 기안 비고
  EDString1: "", // 상황에 따라 다르게 쓰임. 전자근로계약서에선 사용하지 않음
  EDString2: "",
  EDString3: "",
  EDString4: "",
  EDString5: "",
  EDString6: "",
  EDString7: "",
  EDString8: "",
  EDString9: "",
  EDString10: "",
  EDTimeStamp1: "1800-01-01",
  EDTimeStamp2: "1800-01-01",
  EDTimeStamp3: "1800-01-01",
  EDTimeStamp4: "1800-01-01",
  EDTimeStamp5: "1800-01-01",
  EDInteger1: "0",
  EDInteger2: "0",
  EDInteger3: "0",
  EDInteger4: "0",
  EDInteger5: "0",
  EDFloat1: "0.0",
  EDFloat2: "0.0",
  EDFloat3: "0.0",
  EDFloat4: "0.0",
  EDFloat5: "0.0",
  EDEJSeq: "", // 기안 순서, 최초일땐 0 고정
  EDLastJoinYN: "", // 마지막 결재 여부, 최초일땐 N
  EDLastDateTime: "", // 수정된 시간
  EDLastDateTimeMilliSecond: "",
  EDSTCode: "", // 최초기안자 코드
  EDSTNameKor: "", //최초기안자 이름(현재 사용 x, 공백 전송)
  EDSUBuseo: "", //최초기안자 부서(현재 사용 x, 공백 전송)
  EDSUJikcheck: "", //최초기안자 직책(현재 사용 x, 공백 전송)
  EJSignGubun: "", //결재 구분코드 최초기안 = 1
  EJOpenDateTime: "1800-01-01", // 열람 시간
  EJBefJoinSTCode: "", //직전 결재자 = 최초기안일땐 기안자와 동일
  EJAftJoinSTCode: "", // 직후 결재자 = 선택한 결재권자
  ERSTCode: [], // 참조자들 리스트
  EROpenDateTime: "1800-01-01" // 참조자들 열람 시간
};

export function _parceDate(exDate) {
  var result = "";
  if (parseInt(exDate) < 10) {
    result = "0" + parseInt(exDate);
  } else {
    result = exDate;
  }
  return result.toString();
}
